import React from 'react';
import ClientProfileDetails from '../../../../../../shared/ClientProfile/ClientProfileDetails';
import { SideDrawerContainer } from '../../../../../../v2BaseComponents/SideDrawer';

export type ClientProfileDetailsSideDrawerContentOwnProps = {
    clientMedicalProfileId: string;
    clientRecordId?: string;
};

export type ClientProfileDetailsSideDrawerContentProps = ClientProfileDetailsSideDrawerContentOwnProps;

const ClientProfileDetailsSideDrawerContent: React.FC<ClientProfileDetailsSideDrawerContentProps> = ({
    clientMedicalProfileId,
    clientRecordId,
}) => {
    return (
        <SideDrawerContainer>
            <ClientProfileDetails clientProfileId={clientMedicalProfileId} clientRecordId={clientRecordId} />
        </SideDrawerContainer>
    );
};

export default React.memo(ClientProfileDetailsSideDrawerContent);
